export default __webpack_public_path__ + "static/media/228.2bee705f.jpg";